import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import "rxjs/add/operator/map";
import "rxjs/add/operator/distinctUntilChanged";
import {Router} from "@angular/router";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {User} from "../models/user.model";
import {Conf} from "../settings/config";
import {Observable} from "rxjs/Observable";

@Injectable()
export class AuthServices {
  currentUserSubject = new BehaviorSubject<User>(new User());
  currentUser = this.currentUserSubject.asObservable().distinctUntilChanged();

  constructor(private http: HttpClient, private router: Router) {

  }

  getToken(): string {
    return localStorage.getItem('token');
  }

  getAuthUser() {
    var loggeduser = localStorage.getItem('loggeduser');
    if (loggeduser) {
      var user = $.parseJSON(loggeduser)
      this.currentUserSubject.next(user);
    }
  }

  getCurrentUserId(): number {
    return parseInt(atob(localStorage.getItem('user_id')), 0);
  }

  saveToken(token: string): void {
    localStorage.setItem('token', token);
  }

  destroyToken(): void {
    localStorage.removeItem('token');
  }

  initAuth(): void {
    if (this.getToken()) {
      this.getAuthenticatedUser()
          .subscribe((user: User) => {
            this.setAuth(user);
          });
    } else {
      this.purgeAuth();
    }
  }

  setAuth(user: User): void {
    this.currentUserSubject.next(user);
    localStorage.setItem('loggeduser', JSON.stringify(user));
  }

  purgeAuth() {
    this.currentUserSubject.next(new User());
    localStorage.removeItem('loggeduser');
  }

  getCurrentUser(): User {
    return this.currentUserSubject.value;
  }

  register(regType, body: Object): Observable<User> {
    body['auth_type'] = regType;

    return this.http
        .post(`${Conf.API_URL}/api/v0/auth-users/register/`, body)
        .map((user: User) => {
          return user;
        });
  }

  login(credentials: Object): Observable<User> {
    return this.http
        .post(`${Conf.API_URL}/api/v0/auth-users/login/`, credentials)
        .map((user: User) => {
          this.setAuth(user);
          return user;
        });
  }

  getAuthenticatedUser(): Observable<User> {
    const user_id = this.getCurrentUserId();
    const token = this.getToken();
    const headers = new HttpHeaders({'Authorization': `Token ${token}`});

    return this.http
        .get(`${Conf.API_URL}/users/${user_id}/`, {headers: headers})
        .map((user: User) => {
          return user;
        });
  }

  logout(): void {
    this.purgeAuth();
    this.router.navigateByUrl('/');
  }

  confirmAccount(token: string): Observable<any> {
    return this.http
        .post(`${Conf.API_URL}/api/v0/auth-users/confirm-account/`, {token: token})
        .map(response => {
          return response;
        });
  }

}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/services/auth.service.ts